import HeapAnalytics from './HeapAnalytics';
import { config } from './ConfigService';

// Single shared instance for the whole application. Heap's App ID is a runtime
// config value (public/js/config.json), so initialization is deferred until
// that config has finished loading.
const heapAnalytics = new HeapAnalytics();

config.instance.then(() => {
  heapAnalytics.enabled = config.getProperty('HEAP_ENABLED') === true
    || config.getProperty('HEAP_ENABLED') === 'true';
  heapAnalytics.appId = config.getProperty('HEAP_APP_ID');
  heapAnalytics.development = config.getProperty('HEAP_DEVELOPMENT') === true
    || config.getProperty('HEAP_DEVELOPMENT') === 'true';
  heapAnalytics.applicationName = config.getProperty('HEAP_APPLICATION_NAME') || 'WCPP';
  heapAnalytics.environment = config.getProperty('HEAP_ENVIRONMENT');
  heapAnalytics.initialize();
});

export default heapAnalytics;
